import React, { useEffect } from 'react';
import { login, logout } from '../Utils/Cookies.js';
import api from "../tbrosApi.js"
import {
  buildAndroidAppHandoffUrl,
  consumeSocialLoginFlow,
  isAndroidAppLoginSource,
  resolveTrustedWebUrl,
} from './SocialLoginUtils.js';

const KakaoLoginCallback = () => {

  const queryParams = new URLSearchParams(window.location.search)
  const redirectUri = encodeURIComponent(window.location.origin + `/auth/callback/kakao`)
  const code = queryParams.get("code")
  const state = queryParams.get("state")
  const socialLoginFlow = consumeSocialLoginFlow(state)
  const successCallback = (socialLoginFlow && socialLoginFlow.successCallback) || queryParams.get("successCallback")
  const failCallback = (socialLoginFlow && socialLoginFlow.failCallback) || queryParams.get("failCallback")
  const isAndroidAppFlow = isAndroidAppLoginSource(socialLoginFlow && socialLoginFlow.source)

  const getValidCallback = (callback) => {
    if (!callback || callback === "null" || callback.trim() === "") {
      return null
    }
    return callback
  }

  const validSuccessCallback = getValidCallback(successCallback)
  const validFailCallback = getValidCallback(failCallback)
  const failUrl = resolveTrustedWebUrl(validFailCallback, "/")

  const getTargetWebUrl = async () => {
    const heroes = JSON.parse(localStorage.getItem("heroes"))
    if (heroes && heroes.length > 1) {
      return resolveTrustedWebUrl(validSuccessCallback, "/")
    }

    return resolveTrustedWebUrl(validSuccessCallback, "/heroes")
  }

  const getAccessToken = async () => {
    if (!code || !state) {
      alert("Invalid login request.")
      window.location = failUrl
      return
    }

    const response = await api.get(`/login/kakao?code=${code}&state=${state}&redirectUrl=${redirectUri}`)
    if (response && response.data && response.data.accessToken) {
      const accessToken = response.data.accessToken
      await login(accessToken)
      const targetWebUrl = await getTargetWebUrl()

      if (isAndroidAppFlow) {
        const handoffUrl = buildAndroidAppHandoffUrl({
          accessToken,
          targetWebUrl,
          fallbackUrl: targetWebUrl,
        })

        if (handoffUrl) {
          window.location.replace(handoffUrl)
          return
        }
      }

      window.location = targetWebUrl
    } else {
      alert("Login failed.")
      logout()
      window.location = failUrl
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getAccessToken()
  }, []);

  return (
    <></>
  )
}

export default KakaoLoginCallback
